import React from 'react';

import UnionPayCardIcon from '@ott/icon-union-pay-card';
import AmexCardIcon from '@ott/icon-amex-card';
import MasterCardIcon from '@ott/icon-mastercard-card';
import MaestroCardIcon from '@ott/icon-maestro-card';
import VisaCardIcon from '@ott/icon-visa-card';
import MirPayCardIcon from '@ott/icon-mir-card';
import DinersClubCardIcon from '@ott/icon-diners-club-card';
import OttCardIcon from '@ott/icon-virtual-card';
import DefaultCardIcon from '@ott/icon-default-card';

export const CardIcon = ({ type }) => {
  switch (type) {
    case 'visa':
      return <VisaCardIcon />;

    case 'maestro':
      return <MaestroCardIcon />;

    case 'mastercard':
      return <MasterCardIcon />;

    case 'americanexpress':
      return <AmexCardIcon />;

    case 'unionpay':
      return <UnionPayCardIcon />;

    case 'mir':
      return <MirPayCardIcon />;

    case 'dinersclub':
      return <DinersClubCardIcon />;

    case 'ott':
      return <OttCardIcon />;

    case 'default':
    default:
      return <DefaultCardIcon />;
  }
};
